module.exports = __webpack_public_path__ + "static/media/published-icon.ce63b208.svg";